import { render, staticRenderFns } from "./FormularioDesecho.vue?vue&type=template&id=507e82c2"
import script from "./FormularioDesecho.vue?vue&type=script&lang=ts"
export * from "./FormularioDesecho.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports